import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { TaskTrackerFilter } from '../domain.types'
import { createEmptyFiltersCatalogState } from './filtersCatalog.state.utils'
import {
  fetchFiltersCatalogThunk,
  reorderFilterThunk,
} from './filtersCatalog.thunks'

const filtersCatalogSlice = createSlice({
  name: 'taskTrackerFiltersCatalog',
  initialState: createEmptyFiltersCatalogState(),
  reducers: {
    applyFiltersCatalog(state, action: PayloadAction<TaskTrackerFilter[]>) {
      state.filters = action.payload
      state.error = null
    },
    setFiltersCatalogLoadError(state, action: PayloadAction<string>) {
      state.loading = false
      state.filters = []
      state.error = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFiltersCatalogThunk.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchFiltersCatalogThunk.fulfilled, (state, action) => {
        state.loading = false
        state.filters = action.payload
      })
      .addCase(fetchFiltersCatalogThunk.rejected, (state, action) => {
        state.loading = false
        state.filters = []
        state.error =
          (action.payload as string) ?? 'Не удалось загрузить каталог стикеров'
      })
      .addCase(reorderFilterThunk.pending, (state, action) => {
        state.reorderingFilterId = action.meta.arg.activeFilterId
        state.filters = action.meta.arg.reorderedFilters
      })
      .addCase(reorderFilterThunk.fulfilled, (state, action) => {
        state.reorderingFilterId = null
        if (!action.payload) return
        state.filters = action.payload.updatedFilters
      })
      .addCase(reorderFilterThunk.rejected, (state, action) => {
        state.reorderingFilterId = null
        const payload = action.payload as {
          previousFilters: TaskTrackerFilter[]
        }
        if (payload?.previousFilters) {
          state.filters = payload.previousFilters
        }
      })
  },
})

export const { applyFiltersCatalog, setFiltersCatalogLoadError } =
  filtersCatalogSlice.actions

export default filtersCatalogSlice.reducer
